module.exports = __webpack_public_path__ + "static/media/setpoint-chlodzenie.954cde30.svg";